import {
  ApiRequest,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/chatbot'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function SpecialistAvailable(data) {
  return ApiRequest.get(`${BaseRoute}/specialistAvailableStatus`, {
    params: data,
  })
}

function FindSpecialistByName(name) {
  return ApiRequest.get(
    `${BaseRoute}/findSpecialistByName?specialistName=${name}`
  )
}

function GetIntents(userPrompt, systemPrompt) {
  return ApiRequest.post(`${BaseRoute}/getIntents`, {
    userPrompt,
    systemPrompt,
  })
}
const API = {
  ...baseFunctions,
  SpecialistAvailable,
  FindSpecialistByName,
  GetIntents,
}

export default API
